import { EnergyType } from '@energy-retailer/constants';
import { isUndefined } from 'lodash';

const formatProductPlanTariff = ({
  tariff,
  type,
  supply,
  showZero = false,
}: {
  tariff?: number;
  type?: EnergyType;
  supply?: boolean;
  showZero?: boolean;
}) => {
  if (isUndefined(tariff)) {
    return undefined;
  }

  if (Number(tariff) === 0 && !showZero) {
    return undefined;
  }

  if (supply) return `${tariff}c/day`;

  switch (type) {
    case EnergyType.Gas:
      return `${tariff}c/MJ`;
    case EnergyType.Electricity:
    default:
      return `${tariff}c/kWh`;
  }
};

export { formatProductPlanTariff };
